export * from './base-tree-node.component';


// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/base-tree-node/index.ts